import { useGetUser } from 'v2/core/services/user';
import { UserRowRoleType } from '../store/types';
import { mapUserTypeToUserRowRoleType } from '../utils';

const USER_ROLES_PRIORITY_ORDER: Record<string, number> = {
  [UserRowRoleType.SuperAdmin]: 8,
  [UserRowRoleType.Admin]: 7,
  [UserRowRoleType.SuperEditor]: 6,
  [UserRowRoleType.Editor]: 5,
  [UserRowRoleType.SuperMember]: 4,
  [UserRowRoleType.Member]: 3,
  [UserRowRoleType.SuperViewer]: 2,
  [UserRowRoleType.Viewer]: 1,
};

export const useGetDefaultInvitationForUserRole = (
  userRole: UserRowRoleType,
) => {
  const {
    tenant: {
      dashboardSettings: { defaultUserType },
    },
  } = useGetUser();

  const defaultUserRole =
    mapUserTypeToUserRowRoleType(defaultUserType) ?? UserRowRoleType.Editor;

  const userRolePriority = USER_ROLES_PRIORITY_ORDER[userRole];
  const defaultUserRolePriority = USER_ROLES_PRIORITY_ORDER[defaultUserRole];

  if (userRolePriority > defaultUserRolePriority) {
    return defaultUserRole;
  }

  return userRole;
};
